module.exports = __webpack_public_path__ + "media/hyper/images/features-2-94291ca04f87478ad98f713b37d355de.svg";